import { useQuery } from 'react-query';
import { AadeBookInvoiceType } from '../../../interfaces/myData.interface';
import { parseProviderInvoiceXml } from '../../../services/utils/parseProviderInvoiceXml';

export const isProviderQrUrl = (url: string | undefined): boolean =>
  !!url && !url.includes('aade.gr');

const tryFetchXml = async (url: string): Promise<AadeBookInvoiceType | null> => {
  const resp = await fetch(url);
  if (!resp.ok) return null;
  const xml = await resp.text();
  return parseProviderInvoiceXml(xml);
};

const fetchProviderInvoice = async (qrUrl: string): Promise<AadeBookInvoiceType | null> => {
  // Some providers (e.g. fiskaltrust) expose XML at <url>/myDATA
  try {
    const fromMyData = await tryFetchXml(`${qrUrl}/myDATA`);
    if (fromMyData) return fromMyData;
  } catch {
    // endpoint not available, fall through
  }

  // Other providers (e.g. primer.gr) return XML directly at the QR URL itself
  // Content-Disposition: attachment triggers a browser download but fetch() gets the body normally
  const fromUrl = await tryFetchXml(qrUrl);
  if (fromUrl) return fromUrl;

  throw new Error('No valid invoice XML found at provider URL');
};

export const useProviderInvoice = (qrUrl: string | undefined) => {
  return useQuery<AadeBookInvoiceType | null, Error>(
    ['useProviderInvoice', qrUrl],
    () => fetchProviderInvoice(qrUrl!),
    {
      enabled: isProviderQrUrl(qrUrl),
      staleTime: 5 * 60 * 1000,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
};
